import Symbol from "./Symbol";
import { INSPECTOR_POWER_SWITCH } from "../../../constants/inspectorConstants";

// Interruptores de Potencia
class PowerSwitch extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("PowerSwitch", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente nominal" },
            interruptingCapacity: { isVisible: false, value: null, label: "Capacidad interruptiva" },
            instantInterruptingCapacity: { isVisible: false, value: null, label: "Capacidad Interruptiva Instantánea" },
            breakTime: { isVisible: false, value: null, label: "Tiempo de Apertura" },
        };                
    }

    getInspector() {
        return INSPECTOR_POWER_SWITCH;
    }
}

export default PowerSwitch;
